module.exports = __webpack_public_path__ + "static/main_building-161dc8e000909b96321f4be079d37b00.jpg";